import type { ApiErrorCode } from "@packages/shared-types";
import type { AxiosError } from "axios";

export interface ApiErrorPayload {
	code?: string;
	message?: string;
	details?: Record<string, unknown>;
}

export function extractApiError(error: unknown): ApiErrorPayload | undefined {
	const axiosError = error as AxiosError<ApiErrorPayload>;
	return axiosError?.response?.data;
}

export function getErrorCode(error: unknown): ApiErrorCode | undefined {
	return extractApiError(error)?.code as ApiErrorCode | undefined;
}
